<template>
  <div class="menu_box">
    <el-menu
      text-color="#fff"
          background-color="rgba(0, 0, 0, 0.8)"
          active-text-color="#fff"
      class="el-menu-middle"
      mode="vertical"
      @select="handleSelect"
    >
      <el-menu-item
        v-for="(item, index) in menuArr"
        :key="index"
        :index="langSet=='cn'?item.http_url_cn:item.http_url_en"
        ><span>{{ langSet=='cn'?item.name_cn:item.name_en }}</span></el-menu-item
      >
    </el-menu>
  </div>
</template>

<script>
import router from "../router/index.js";
import {getlistCate,getWebMenu} from "@/api/api";
export default {
  data() {
    return {
      menuArr: [],
    };
  },
  created() {
    localStorage.getItem("languageSet");
  },
  mounted() {
    this.navDefalut();
    this.getMenu()
    this.langSet = localStorage.getItem("languageSet") || "cn";
  },
  computed: {
    getActive: function () {
      var path = this.$router.path.split("/");
      return path;
    },
  },
  methods: {
    startsWithSlash(str) {
      return /^\//.test(str);
    },
    handleSelect(key, keyPath) {
        if(key){
           if(this.startsWithSlash(key)){
                this.$router.push({
                  path:key
                })
           }else{
            let path=window.location.protocol+'//'+key
             window.open(path,'_blank')
           }
        }
      },
    getMenu(){
      let arr=[];
     let data={
       page_type:0
     }
      getWebMenu(data).then(res=>{
          
          if(res.code == 1){
            let lists=res.data.lists;
            lists.map((item,index)=>{
               if(item.is_top=="是"){
                arr.push(item)
               }
            })
            this.menuArr=arr;
          //  zhang 获取资料下载二级数据
            // arr[4].children=[];
            // let pid=this.langSet=='cn'?6:7
            // let data1={pid:pid}
            // getlistCate(data1).then(res=>{
            //     if(res.code == 1){
            //       let lists=res.data.lists;
            //       lists.map(item=>{
            //         arr[4].children.push({
            //           name_cn:item.name,
            //           name_en:item.name,
            //           id:item.id,
            //           http_url_cn:'/download',
            //           http_url_en:'/download'
            //         })
            //       })
            //       this.menuArr=arr;
            //     }
                  
            //   }).catch(err=>{
            //     console.log(err)
            //   })
          }
            
        }).catch(err=>{
          console.log(err)
        })
    },
    navDefalut() {
      this.menuArr.forEach((item) => {
        if (item.name == "首页") {
          item.name = this.$t("navMenu.home");
        } else if (item.name == "关于展会") {
          item.name = this.$t("navMenu.about");
        } else if (item.name == "学术报告会") {
          item.name = this.$t("navMenu.report");
        } else if (item.name == "展会服务") {
          item.name = this.$t("navMenu.service");
        } else if (item.name == "资料下载") {
          item.name = this.$t("navMenu.download");
        } else if (item.name == "联系我们") {
          item.name = this.$t("navMenu.contact");
        }
      });
      this.menuArr = this.menuArr;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu {
  padding: 0 0.34rem;
  box-sizing: border-box;
}
.el-menu-item {
  border-bottom: 1px solid #fff;
  font-size: 0.34rem;
  line-height: 28px;
  padding: 0.2rem 0;
  height: auto;
}
.el-menu-item:last-child {
  border-bottom: 0;
}
.el-menu-middle{
 
  background: rgba($color: #000000, $alpha: 0.8);
}
.menu_box{
  // position: fixed;
  // top: 0.88rem;
  // left: 0;
  width: 100%;
  z-index: 10;
  

}
</style>